import * as React from 'react';
import PropTypes from 'prop-types';
import { cn } from '../../lib/utils';

export const Label = React.forwardRef(({ className, ...props }, ref) => (
  <label ref={ref} className={cn('text-sm font-semibold text-slate-700', className)} {...props} />
));
Label.displayName = 'Label';
Label.propTypes = { className: PropTypes.string };
